import React, {forwardRef, useState} from 'react';
import {Button} from "react-bootstrap";
import COLORS, {getCoverPhotoStoragePath} from "../Helpers/utils";
import LabelTag from "./LabelTagComponent";
import {useNavigate} from "react-router-dom";
import noReception from "../Images/no_reception.png"
import {BuildingSummary} from "../types/protocols";
import {colorForBuildingType} from "../types/BuildingTypeEnums";
import {placeholderForBuildingType} from "../Helpers/PlaceholderUtils";
import {FirebaseImage, ImageSize} from "../Helpers/ImageLoader";
import {translate} from "../types/EnumTranslations";

interface BuildingListItemProps {
    building: BuildingSummary;
    highlighted: boolean;
    category1Label: string;
    category2Label: string;
    onClick: (id: string) => void;
    visible: boolean;
}

const BuildingListItem = forwardRef<HTMLLIElement, BuildingListItemProps>(
    ({ building, highlighted, category1Label, category2Label, onClick, visible }, ref) => {
        const navigate = useNavigate();
        const handleClick = (event: React.MouseEvent) => {
            if (event.ctrlKey || event.metaKey) {
                // Ctrl+click (or Cmd+click on Mac) - open in new tab
                window.open(`/building/${building.key}`, '_blank');
            } else {
                // Normal click - navigate in same tab
                navigate(`/building/${building.key}`);
            }
        };

        const [isHovered, setIsHovered] = useState(false);

        return (
            <li
                ref={ref}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{
                    display: visible ? 'flex' : 'none',
                    alignItems: 'stretch',
                    paddingRight: '1rem',
                    cursor: 'pointer',
                }}
                onClick={() => onClick(building.name!)}
            >
                <div
                    style={{
                        backgroundColor: highlighted ? COLORS.primaryDark : 'transparent',
                        width: '0.4rem',
                        borderRadius: '1rem',
                        marginRight: '0.3rem',
                        marginLeft: '0.3rem',
                    }}
                />

                {/* White main card on the right */}
                <div
                    style={{
                        position: 'relative',
                        backgroundColor: '#fff',
                        borderRadius: '10px',
                        padding: '1rem',
                        boxShadow: highlighted || isHovered ? '0 2px 4px rgba(0, 0, 0, 0.4)' : '0 2px 4px rgba(0, 0, 0, 0.1)',
                        flex: 1,
                    }}
                >
                    <div style={{
                        position: 'absolute',
                        top: '1rem',
                        right: '1rem',
                        display: 'flex',
                        gap: '0.5rem'
                    }}>
                        {
                            building.buildingInfo?.hasPoorReception &&
                            <img
                                src={noReception}
                                alt="No reception"
                                style={{
                                    width: '24px',
                                    height: '24px',
                                }}
                            />
                        }
                        <FirebaseImage
                            storagePath={getCoverPhotoStoragePath(building)} size={ImageSize.THUMBNAIL_SMALL}
                            alt="Building"
                            style={{
                                width: '80px',
                                height: '80px',
                                objectFit: 'cover',
                                objectPosition: 'center',
                            }}
                            placeholder={placeholderForBuildingType(building.buildingType)}
                        />
                    </div>
                    <div style={{ textAlign: 'left', marginRight: '90px' }}>
                        <LabelTag text={translate(building.buildingType).toUpperCase()} backgroundColor={colorForBuildingType(building.buildingType)}/>
                        <br/>
                        {
                            building.groupTags &&
                            Object.values(building.groupTags).map((tag, index)=> {
                                return <LabelTag key={`${tag.tag}-${index}`} text={tag.tag} backgroundColor={COLORS.redOrange}/>
                            })
                        }
                        <strong style={{
                            marginTop: '5px',
                            fontSize: '12pt',
                            display: 'block',
                            marginBottom: '0rem',
                        }}>
                            {building.name}
                        </strong>

                        {
                            (building.locationCategories?.category1?.name || building.locationCategories?.category2?.name) &&
                            <span style={{
                                fontSize: '10pt',
                                color: '#444444',
                                display: 'block',
                            }}>
                                {
                                    building.locationCategories?.category2?.name &&
                                    <div style={{ marginBottom: '-0.2rem' }}>{category2Label}: {building.locationCategories?.category2?.name}</div>
                                }
                                {
                                    building.locationCategories?.category1?.name &&
                                    <div>{category1Label}: {building.locationCategories?.category1?.name}</div>
                                }

                                </span>
                        }

                        <Button
                            className={"small-button-style"}
                            style={{marginTop: '30px'}}
                            variant="secondary"
                            onClick={handleClick} >
                            ÖPPNA
                        </Button>
                    </div>
                </div>
            </li>
        );
    }
);

export default BuildingListItem;